import React, { useState } from "react";
import { Settings } from "lucide-react";
import "../../assets/css/layout/student/Header.css";
import { useNavigate } from "react-router-dom";
import NotificationDropdown from "../../screens/student/dashboard/notificationdropdown/NotificationDropdown";

const Header = () => {
  const navigate = useNavigate();

  return (
    <header className="stnb-header">
      <div className="stnb-header-left">
        <h1 className="stnb-welcome-text">Welcome students!</h1>
      </div>

      <div className="stnb-header-right"> 
        {/* Notifications Dropdown */}
        <NotificationDropdown /> 

        {/* Settings Button - Direct Navigation */}
        <button
          className="stnb-icon-btn"
          onClick={() => navigate("/student/settings")}
        >
          <Settings size={20} />
        </button>
      </div> 
    </header>
  );
};

export default Header;